import { Field, InputType } from 'type-graphql'
import { Address } from '../address/Address'
import { ActionArgs } from '../action/ActionArgs'
import type { IAction } from '../action/IAction'

@InputType()
export class ManageCustomerOrCompanyAddressServiceArgs extends ActionArgs {
  @Field(() => Address)
  address: Address

  @Field(() => String)
  customerId: string
}

export interface IManageCustomerOrCompanyAddressService extends IAction<void, ManageCustomerOrCompanyAddressServiceArgs> {}
